import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as actionsHeader } from '../../redux/actions/site';
import avatar from './../../assets/avatares/inteiro_paciente.png';
import './Loading.scss';


const Loading = props => {
    const msg = useSelector(state => state.site.loadingMsg);
    const dispatch = useDispatch();
    
    const close = () => {
        dispatch(actionsHeader.setLoadingMsg(''));
    }

    const action = (e) => {
        e.stopPropagation();
        if(typeof msg === 'object' && msg.action) {
            if(msg.action.goto){
                document.location.pathname = msg.action.goto;
            }
        }
    }
    
    if ((typeof msg === 'string' && msg.length > 0) || (typeof msg === 'object' && msg.msg.length > 0)) {
        
        return (
            <div onClick={close} className="loading">
                <h1 onClick={action}>
                    <img src={avatar} alt="leka" /> {typeof msg === 'string' && msg} {typeof msg === 'object' && msg.msg}
                </h1>
            </div>
        );
    } else {
        return <></>;
    }
}

export default Loading;